//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamAdmSpisovyPlanDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      FFIALA                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-03-10                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.15.2
//AdtGeneratorConfig:[ T:(sslsspl) GID:(Web.Set.Des.Ts) V1:(spis_pl,lic,aktivita,arw,poznamka,dat_od,dat_do,dat_zmena,zmenu_prov,nazev,popis,priz_vycet,oddelovace,prirustek,priz_num,priz_manual,priz_check_lev,root_level,priz_end_znak,ixs_tre,spis_pl_ext) V2:() K1:() K2:() ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamAdmSpisovyPlanDesigner
     * 
     * @author FFIALA
     * @since 482.1.0.119
     */
    export class SeznamAdmSpisovyPlanDesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
            /** PK - spis_pl */
            public spis_pl: string;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GAdmSpisovyPlanListDto>;

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamAdmSpisovyPlanDesigner>, spis_pl: string  ): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that, spis_pl);
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true, this.applyAction );

            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamAdmSpisovyPlanDesigner>, spis_pl: string ): Forms.Form {

            // vytvo��m form
            var v_filterForm = SeznamBase.createFilterFormBase(that);

            // p�id�m do n�j pol��ka

            return v_filterForm;
        } // createFilterForm

        static applyAction(that: GContentType<SeznamAdmSpisovyPlanDesigner>, ev, ctx): any {
            var filterObj = {
            }
            that.view = new Gordic.Isl.View(that.isl.AdmSpisovyPlan.list({ filters: filterObj }));
            that.grid.ggrid("setData", that.view);
        }

        /**
         * SeznamAdmSpisovyPlanDesignerInit
         * 
         * @param {GContentType<SeznamAdmSpisovyPlanDesigner>} that
         */
        static SeznamAdmSpisovyPlanDesignerInit(that: GContentType<SeznamAdmSpisovyPlanDesigner>, spis_pl: string ) {

            this.SeznamBaseInit(that);
            that.filter = this.createFilter(that, spis_pl);

            that.gridFormat = this.createGridFormatByDataListDescription(that);
            that.gridSearchColumns = this.createGridSearchColumnsByDataListDescription(that);

            var filterObj: any = {}
            that.view = new Gordic.Isl.View(that.isl.AdmSpisovyPlan.list({ filters: filterObj }), { filterPanel: that.filter, startEmpty: false, });       // propojen� ovl�dac�ho prvku gridu se zdrojem dat - a s filter panelem
        } // SeznamAdmSpisovyPlanDesignerInit

    }
}
